import { render, staticRenderFns } from "./ClickToCopy.vue?vue&type=template&id=ec465946&scoped=true"
import script from "./ClickToCopy.vue?vue&type=script&lang=ts"
export * from "./ClickToCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec465946",
  null
  
)

export default component.exports